module.exports = __webpack_public_path__ + "static/media/sf_3200.3048b9fd1836d3864373743e39abbd63.png";